import { useSelector, useDispatch } from "react-redux";
import { Container, Grid, Box, Stack, Typography, Badge } from "@mui/material";
import { Check } from "@mui/icons-material";
import icons from "./iconUndSDGoalsList";
import SDGIcon from "./icons/sdg.png";

import { setSdgServed, selectSdgServed } from "../../slice";

const UNSDGGoalsAlignmentStep = () => {
    const dispatch = useDispatch();
    const selected = useSelector(selectSdgServed);

    const toggleSelect = (goal) => {
        dispatch(
            setSdgServed(
                selected.includes(goal)
                    ? selected.filter((item) => item !== goal)
                    : [...selected, goal]
            )
        );
    };

    return (
        <Container maxWidth="md">
            <Stack alignItems="center" gap={1.5}>
                <img
                    src={SDGIcon}
                    alt="SDG Goals Alignment"
                    width={300}
                    height="auto"
                />
                <Typography color="text.mediumDark">
                    Choose the SDGs your organization supports
                </Typography>
                <Grid container spacing={2}>
                    {icons.map((icon) => {
                        const isSelected = selected.includes(icon.id);
                        return (
                            <Grid
                                key={icon.id}
                                item
                                xs={6}
                                sm={3}
                                lg={2.4}
                                sx={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                    boxSizing: "border-box",
                                }}
                                onClick={() => toggleSelect(icon.id)}
                            >
                                <Badge
                                    badgeContent={
                                        isSelected ? (
                                            <Box
                                                bgcolor="primary.main"
                                                width={24}
                                                height={24}
                                                borderRadius="50%"
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                boxShadow={2}
                                            >
                                                <Check
                                                    sx={{
                                                        color: "#fff",
                                                        fontSize: 20,
                                                    }}
                                                />
                                            </Box>
                                        ) : null
                                    }
                                >
                                    <img
                                        src={icon.file}
                                        alt={icon.name}
                                        draggable={false}
                                        style={{
                                            width: "100%",
                                            display: "block",
                                            margin: "0 auto",
                                            boxShadow:
                                                "0 2px 6px rgba(0,0,0,0.1)",
                                            filter: isSelected
                                                ? "none"
                                                : "grayscale(1)",
                                            transition: "filter 0.5s ease-out",
                                            borderRadius: "7px",
                                        }}
                                    />
                                </Badge>
                            </Grid>
                        );
                    })}
                </Grid>
            </Stack>
        </Container>
    );
};

export default UNSDGGoalsAlignmentStep;
